import Vue from "vue";
export default Vue.extend({
    name: "infoBox",
    data: function () {
        return {};
    },
});



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/InfoBox.vue
// module id = 326
// module chunks = 1